// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnTransparent_my_btn__mlv1k","arrow":"CustomBtnTransparent_arrow__adZcn","arrow_rotated":"CustomBtnTransparent_arrow_rotated__qXUCd"};